import './Home.scss';

import { Col, Row } from 'react-bootstrap';

import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ROUTE_PROFILE_NAME } from '../../utils/constants';
import SubFooter from '../../components/SubFooter/SubFooter';
import bannerImg from '../../assets/images/ubisoft-playtest-home-banner-desktop.webp';
import bannerImgMobile from '../../assets/images/ubisoft-playtest-home-banner-mobile.webp';
import everyoneImg1 from '../../assets/images/ubisoft-playtest-home-everyone-1.webp';
import everyoneImg2 from '../../assets/images/ubisoft-playtest-home-everyone-2.webp';
import everyoneImg3 from '../../assets/images/ubisoft-playtest-home-everyone-3.webp';
import everyoneImg4 from '../../assets/images/ubisoft-playtest-home-everyone-4.webp';
import messages from './messages';
import playtestImg01 from '../../assets/images/ubisoft-playtest-home-participate.webp';
import playtestImg02 from '../../assets/images/ubisoft-playtest-home-share.webp';
import remoteImg from '../../assets/images/ubisoft-playtest-home-remote.webp';
import rewardImg01 from '../../assets/images/ubisoft-playtest-profile-icon-gamepad-pink.webp';
import rewardImg02 from '../../assets/images/ubisoft-playtest-profile-icon-reward-pink.webp';
import rewardImg03 from '../../assets/images/ubisoft-playtest-profile-icon-gamepad-and-money.webp';
import { selectAuth } from '../../ducks/auth';
import { selectLocalSettings } from '../../ducks/settings';
import { setTitle } from '../../utils/generic';
import siteMessages from '../../pages/root/siteMessages';
import studioImg from '../../assets/images/ubisoft-playtest-home-studio.webp';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

interface Props {
  onClickLogin: () => void;
}

const Home = (props: Props) => {
  const intl = useIntl();
  const auth = useSelector(selectAuth);
  const lang = useSelector(selectLocalSettings);

  useEffect(() => {
    setTitle(intl.formatMessage({ ...messages.pageTitle }));
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page page-home">
      <div className="page__header">
        <img src={bannerImg} alt="" className="homeBannerImg bannerDesktop" />
        <img
          src={bannerImgMobile}
          alt=""
          className="homeBannerImg bannerMobile"
        />
        <div className="blackOverlay" />
        <div className="content banner-content">
          <h1 className="title">
            {intl.formatMessage({ ...messages.heading })}
          </h1>
          <p>{intl.formatMessage({ ...messages.description })}</p>
          <Row className="banner-buttons">
            <Col sm>
              {auth.ticket ? (
                <Link to={`/${lang}/${ROUTE_PROFILE_NAME}`} tabIndex={-1}>
                  <Button>
                    {intl.formatMessage({ ...siteMessages.myProfile })}
                  </Button>
                </Link>
              ) : (
                <Button onClick={props.onClickLogin}>
                  {intl.formatMessage({ ...siteMessages.createProfile })}
                </Button>
              )}
            </Col>
          </Row>
        </div>
      </div>
      <div className="container home">
        <h2>{intl.formatMessage({ ...messages.playtest })}</h2>
        <Row className="playtest">
          <Col md>
            <img src={playtestImg01} alt="" />
            <div className="image-title image-title-home">
              {intl.formatMessage({ ...messages.ubisoftHalifax })}
            </div>
          </Col>
          <Col md className="d-flex align-items-end">
            <div className="text">
              <h3>{intl.formatMessage({ ...messages.playtestHeader01 })}</h3>
              <p>{intl.formatMessage({ ...messages.playtestDesc01 })}</p>
            </div>
          </Col>
        </Row>
        <Row className="playtest d-flex flex-row-reverse">
          <Col md className="image-reverse">
            <img src={playtestImg02} alt="" />
            <div className="image-title image-title-home image-title-home-reverse">
              {intl.formatMessage({ ...messages.ubisoftMontreal })}
            </div>
          </Col>
          <Col md className="d-flex align-items-end">
            <div className="text">
              <h3>{intl.formatMessage({ ...messages.playtestHeader02 })}</h3>
              <p>{intl.formatMessage({ ...messages.playtestDesc02 })}</p>
            </div>
          </Col>
        </Row>
        <div className="reward">
          <div className="reward-header">
            <h2>{intl.formatMessage({ ...messages.rewardHeader })}</h2>
            <p className="fw-bold">
              {intl.formatMessage({ ...messages.rewardDesc })}
            </p>
          </div>
          <div className="image-wrapper">
            <Row>
              <Col md>
                <img src={rewardImg02} className="rewards" alt="" />
                <p className="text-center">
                  {intl.formatMessage({ ...messages.rewardText02 })}
                </p>
              </Col>
              <Col md>
                <img src={rewardImg01} className="rewards" alt="" />
                <p className="text-center">
                  {intl.formatMessage({ ...messages.rewardText01 })}
                </p>
              </Col>
              <Col md>
                <img src={rewardImg03} className="rewards" alt="" />
                <p className="text-center">
                  {intl.formatMessage({ ...messages.rewardText03 })}
                </p>
              </Col>
            </Row>
          </div>
          <p className="reward-footer">
            {intl.formatMessage({ ...messages.rewardFooter })}
          </p>
        </div>
        <div className="type">
          <Row>
            <h2>{intl.formatMessage({ ...messages.type })}</h2>
          </Row>
          <Row>
            <Col md>
              <div className="image-wrapper">
                <img src={studioImg} alt="" />
                <h4>{intl.formatMessage({ ...messages.studioTestHeader })}</h4>
                <p>{intl.formatMessage({ ...messages.studioTestDesc })}</p>
              </div>
            </Col>
            <Col md>
              <div className="image-wrapper">
                <img src={remoteImg} alt="" />
                <h4>{intl.formatMessage({ ...messages.remoteTestHeader })}</h4>
                <p>{intl.formatMessage({ ...messages.remoteTestDesc })}</p>
              </div>
            </Col>
          </Row>
        </div>
        <div className="other">
          <div className="other-header">
            <h2>{intl.formatMessage({ ...messages.otherHeader })}</h2>
            <p>{intl.formatMessage({ ...messages.otherDesc })}</p>
          </div>
          <Row>
            <Col md>
              <div className="image-wrapper">
                <img src={everyoneImg1} alt="" />
              </div>
              <div className="image-wrapper">
                <img src={everyoneImg2} alt="" />
              </div>
            </Col>
            <Col md>
              <div className="image-wrapper">
                <img src={everyoneImg3} alt="" />
              </div>
              <div className="image-wrapper">
                <img src={everyoneImg4} alt="" />
              </div>
            </Col>
          </Row>
          {auth.ticket ? (
            <Link to={`/${lang}/${ROUTE_PROFILE_NAME}`} tabIndex={-1}>
              <Button>
                {intl.formatMessage({ ...siteMessages.myProfile })}
              </Button>
            </Link>
          ) : (
            <Button onClick={props.onClickLogin}>
              {intl.formatMessage({ ...siteMessages.createProfile })}
            </Button>
          )}
        </div>
        <SubFooter />
      </div>
    </div>
  );
};

export default Home;
